import React from "react";
import CheckBox from "../components/CheckBox";
import { getRoutine, saveDoRoutine, removeDoRoutine } from "../api/routine";
import dayjs from "dayjs";

export default class Routine extends React.Component {
  constructor() {
    super();
    this.state = {
      date: new Date(),
      items: [],
      loading: false,
    };
    this.onClickPrevDay = this.onClickPrevDay.bind(this);
  }

  async componentDidMount() {
    await this.loadData();
  }

  async loadData() {
    this.setState({ loading: true });
    const items = await getRoutine(
      this.state.date.toISOString().substring(0, 10)
    );
    this.setState({
      items: items,
      loading: false,
    });
  }

  async onChangedValue(item) {
    item.DONE = !item.DONE;

    const today = this.state.date.toISOString().substring(0, 10);
    if (item.DONE) {
      const result = await saveDoRoutine({
        DO_DATE: today,
        ROUTINE_ID: +item.ID,
        DONE: item.DONE ? 1 : 0,
      });
      item.DO_ID = result.result.result;
      console.log(result.result);
    } else {
      const result = await removeDoRoutine({
        DO_ID: +item.DO_ID,
      });
      console.log(result);
    }

    const todoList = this.state.items.slice();
    const idx = this.state.items.findIndex((x) => x.ID === item.ID);
    todoList[idx] = item;
    this.setState({
      items: todoList,
    });
  }

  async onClickPrevDay(number) {
    await this.setState({
      date: dayjs(this.state.date).subtract(number, "d").toDate(),
    });

    await this.loadData();
  }

  async onClickToday() {
    await this.setState({
      date: new Date(),
    });

    await this.loadData();
  }

  render() {
    let listEl;
    if (this.state.items.length > 0) {
      listEl = (
        <div className="flex flex-col">
          {this.state.items.map((routine, index) => {
            return (
              <CheckBox
                key={index}
                name={routine.CONTENTS}
                item={routine}
                onClick={() => this.onChangedValue(routine)}
              />
            );
          })}
        </div>
      );
    } else {
      listEl = <div>None</div>;
    }

    return (
      <section>
        Routine
        <div
          className={
            this.state.loading ? "text-sm pb-2 opacity-50" : "text-sm pb-2"
          }
        >
          <div className="py-2">
            <button className="pr-2" onClick={() => this.onClickPrevDay(1)}>
              ◀
            </button>
            <span
              className="border p-1 hover:bg-gray-200 hover:cursor-pointer"
              onClick={() => this.onClickToday()}
            >
              <span>{this.state.date.getFullYear()}.</span>
              <span>{this.state.date.getMonth() + 1}.</span>
              <span>{this.state.date.getDate()}</span>
            </span>
            <button className="pl-2" onClick={() => this.onClickPrevDay(-1)}>
              ▶
            </button>
            <span className="pl-1">
              {this.state.date.getHours()}:
              {this.state.date.getMinutes().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}
            </span>
          </div>
          {listEl}
        </div>
      </section>
    );
  }
}
